<template>
    <!-- Main content -->
    <div class="rbt-main-content">
        <div class="rbt-daynamic-page-content">

            <div class="rbt-dashboard-content pt-5">
                <p class="txt-w-bold txt-blue-1">
                    Relatório de Uso
                </p>
            </div>

            <div class="row mb-4 px-4" v-if="qtdUtilizacoes">
                <!-- TOTAIS -->
                <div class="col-12 box-cinza my-3 p-2">
                    <div class="row">
                        <div class="col-12 col-md-3 text-center">
                            <span>Utilizações no contrato atual</span>

                            <h3 class="bold" style="font-weight:bold;">{{qtdUtilizacoes}}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-4 px-4">
                <div class="chat-box-list ">
                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                        <div class="inner">
                            <h6 class="title">Período</h6>

                            <div class="d-flex justify-content-between align-items-center w-100 txt-black">
                                <div>
                                    <span @click="prev" class="c-pointer me-3"><i class="fas fa-chevron-left"></i></span>
                                    <date-picker class="form-control filter-data" v-model="dtInicio" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                    <span class="mx-3 txt-w-bold">até</span>
                                    <date-picker class="form-control filter-data" v-model="dtFim" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                    <span @click="next" class="c-pointer ms-3"><i class="fas fa-chevron-right"></i></span>
                                </div>
                                <button class="btn btn-border btn-filtrar" @click="filter">Filtrar</button>
                            </div>
                            <!--<div class="row">
                        <nav aria-label="...">
                            <ul class="pagination">
                                <li class="page-item">
                                    <a class="page-link txt-black" href="javascript:void(0)" @click="prev"><i class="fas fa-chevron-left"></i></a>
                                </li>
                                <li class="page-item disabled">
                                    <a class="page-link txt-black" href="javascript:void(0)" tabindex="-1" aria-disabled="true">{{dtInicio}} até {{dtFim}}</a>
                                </li>
                                <li class="page-item">
                                    <a class="page-link txt-black" href="javascript:void(0)" @click="next"><i class="fas fa-chevron-right"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-4 px-4">
                <div class="chat-box-list ">
                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                        <div class="d-flex z-99">
                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Consultas</h6></div>
                            <div class="p-2 flex-shrink-1 ">
                                <div class="btn-grp">
                                    <div :class="'dropdown'">
                                        <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle btn-sollai d-flex justify-content-center align-items-center"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="feather-more-vertical"></i> Opções <!--<i class="feather-more-vertical"></i>-->
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('conversas')"><i class="feather-file-text"></i> Imprimir</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive" id="conversas">
                            <table class="table table-striped ">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Legislação</th>
                                        <th scope="col">Formato</th>
                                        <th scope="col" class="w-25">Pergunta</th>
                                        <th scope="col">Usuário</th>
                                        <th scope="col">Data</th>
                                        <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in lstConversas">
                                        <tr :key="index">
                                            <th scope="row">{{index+1}}</th>
                                            <td>{{item.nmLegislacao}}</td>
                                            <td>{{item.tpPergunta}}</td>
                                            <td><span class="reduz-texto-1">{{item.dsPergunta}}</span></td>
                                            <td>{{item.dsLogin}}</td>
                                            <td>{{item.dtPergunta}}</td>
                                            <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                        </tr>
                                    </template>
                                    <template v-if="lstConversas && lstConversas.length == 0">
                                        <tr>
                                            <th class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</th>
                                        </tr>
                                    </template>
                                </tbody>
                                <tfoot v-if="lstConversas && lstConversas.length > 0">
                                    <tr class="text-end">
                                        <td colspan="100%">
                                            Registros encontrados: {{lstConversas.length}}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <!--<div class="d-flex justify-content-end" v-if="lstConversas.length > 0">
                        <span>
                            Registros encontrados: {{lstConversas.length}}
                        </span>
                    </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4 px-4">
                <div class="chat-box-list ">
                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                        <div class="d-flex z-99">
                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Artefatos</h6></div>
                            <div class="p-2 flex-shrink-1 ">
                                <div class="btn-grp">
                                    <div :class="'dropdown'">
                                        <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle btn-sollai d-flex justify-content-center align-items-center"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="feather-more-vertical"></i> Opções <!--<i class="feather-more-vertical"></i>-->
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('artefatos')"><i class="feather-file-text"></i> Imprimir</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive" id="artefatos">
                            <table class="table table-striped ">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Legislação</th>
                                        <th scope="col">Modelo</th>
                                        <th scope="col">Usuário</th>
                                        <th scope="col">Data</th>
                                        <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in lstArtefatos">
                                        <tr :key="index">
                                            <th scope="row">{{index+1}}</th>
                                            <td>{{item.nmLegislacao}}</td>
                                            <td>{{item.nmModelo}}</td>
                                            <td>{{item.dsLogin}}</td>
                                            <td>{{item.dtInclusao}}</td>
                                            <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                        </tr>
                                    </template>
                                    <template v-if="lstArtefatos && lstArtefatos.length == 0">
                                        <tr>
                                            <th class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</th>
                                        </tr>
                                    </template>
                                </tbody>
                                <tfoot v-if="lstArtefatos && lstArtefatos.length > 0">
                                    <tr class="text-end">
                                        <td colspan="100%">
                                            Registros encontrados: {{lstArtefatos.length}}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <!--<div class="d-flex justify-content-end" v-if="lstArtefatos.length > 0">
                        <span>
                            Registros encontrados: {{lstArtefatos.length}}
                        </span>
                    </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4 px-4">
                <div class="chat-box-list ">
                    <div class="chat-box chat-box-you author-speech bg-flashlight">
                        <div class="d-flex z-99">
                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Researchs</h6></div>
                            <div class="p-2 flex-shrink-1 ">
                                <div class="btn-grp">
                                    <div :class="'dropdown'">
                                        <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle btn-sollai d-flex justify-content-center align-items-center"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="feather-more-vertical"></i> Opções <!--<i class="feather-more-vertical"></i>-->
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('researchs')"><i class="feather-file-text"></i> Imprimir</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive" id="researchs">
                            <table class="table table-striped ">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Usuário</th>
                                        <th scope="col">Data</th>
                                        <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in lstResearchs">
                                        <tr :key="index">
                                            <th scope="row">{{index+1}}</th>
                                            <td>{{item.dsNome}}</td>
                                            <td>{{item.nmTipoResearch}}</td>
                                            <td>{{item.dsLogin}}</td>
                                            <td>{{item.dtInclusao}}</td>
                                            <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                        </tr>
                                    </template>
                                    <template v-if="lstResearchs && lstResearchs.length == 0">
                                        <tr>
                                            <th class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</th>
                                        </tr>
                                    </template>
                                </tbody>
                                <tfoot v-if="lstResearchs && lstResearchs.length > 0">
                                    <tr class="text-end">
                                        <td colspan="100%">
                                            Registros encontrados: {{lstResearchs.length}}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <!--<div class="d-flex justify-content-end" v-if="lstResearchs.length > 0">
                                <span>
                                    Registros encontrados: {{lstResearchs.length}}
                                </span>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';
    
    export default {
        name: 'RelatorioUso',
        components: { DatePicker },
        props: {
        },
        data: function () {
            return {
                qtdUtilizacoes: null,
                lstLegislacao: [],
                lstConversas: null,
                lstArtefatos: null,
                lstResearchs: null,

                dtInicio: moment().add(-7, 'days').format('DD/MM/YYYY'),
                dtFim: moment().format('DD/MM/YYYY'),

                dtInicioFiltro: null,
                dtFimFiltro: null,

                options: {
                    placeholder: '__/__/____',
                },

                flImprimir: false,
                time1: null,
            }
        },
        methods: {
            load() {
                this.dtInicioFiltro = moment(this.dtInicio, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.dtFimFiltro = moment(this.dtFim, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.getLegislacaoes();                
                this.getArtefatos();
                this.getResearchs();
            },

            filter() {
                this.dtInicioFiltro = moment(this.dtInicio, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.dtFimFiltro = moment(this.dtFim, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.getConversas();
                this.getArtefatos();
                this.getResearchs();
            },

            getLegislacaoes() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLegislacao = [];
                            for (let i = 0; i < res.data.data.length; i++) {
                                var item = res.data.data[i];

                                $this.lstLegislacao.push({ value: item.idLegislacao, titulo: item.dsNome, descricao: item.dsLegislacao });
                            }
                            this.getConversas();
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            getConversas() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/Get`, { showLoading: true, params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstConversas = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                var nmLegislacao, status, dtAtualizacao = '';
                                if (item.lstConversaMovimento.length > 0) {
                                    status = item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dsMovimento;
                                    dtAtualizacao = moment(item.lstConversaMovimento[item.lstConversaMovimento.length - 1].dtInclusao).format('DD/MM/YYYY [às] HH:mm');
                                }
                                if ($this.lstLegislacao.length > 0) {
                                    if ($this.lstLegislacao.find(x => x.value == item.conversa.idLegislacao)) {
                                        nmLegislacao = $this.lstLegislacao.find(x => x.value == item.conversa.idLegislacao).titulo;
                                    }
                                }

                                var pergunta = {
                                    idConversa: item.conversa.idConversa,
                                    dsPergunta: item.conversa.dsPergunta,
                                    dsResposta: item.conversa.dsResposta,
                                    tpPergunta: (item.conversa.tpPergunta == "RO" || item.conversa.tpPergunta == "Resposta Objetiva" ? "Resposta Objetiva" : "Parecer Técnico"),
                                    dsLogin: item.conversa.dsLogin,
                                    dtPergunta: moment(item.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    status: status,
                                    dtAtualizacao: dtAtualizacao,
                                    nmLegislacao: nmLegislacao,
                                };
                                $this.lstConversas.push(pergunta);
                            }
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        console.log(res);
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },

            getArtefatos() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Get`, { showLoading: true, params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstArtefatos = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                var status = '';
                                if (item.lstArtefatoMovimento.length > 0) {
                                    status = item.lstArtefatoMovimento[item.lstArtefatoMovimento.length - 1].dsMovimento;
                                }

                                var artefato = {
                                    idArtefato: item.artefato.idArtefato,
                                    dsLogin: item.artefato.dsLogin,
                                    dsNome: item.artefato.dsNome,
                                    dtInclusao: moment(item.artefato.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmModelo: item.modeloArtefato.nmModelo,
                                    status: status,
                                    nmLegislacao: (item.modeloArtefato.idLegislacaoModeloArtefato == 1 ? "14.133" : "13.303"),
                                };
                                $this.lstArtefatos.push(artefato);
                            }
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    })
                    .catch(res => {
                        console.log(res);
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    });
            },

            getResearchs() {
                let $this = this;
                axios.get(`${urlApi}/Research/Get`, { showLoading: true, params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstResearchs = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                var status = '';
                                if (item.lstResearchMovimento.length > 0) {
                                    status = item.lstResearchMovimento[item.lstResearchMovimento.length - 1].dsMovimento;
                                }

                                var research = {
                                    idResearch: item.research.idResearch,
                                    dsLogin: item.research.dsLogin,
                                    dsNome: item.research.dsNome,
                                    dtInclusao: moment(item.research.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmTipoResearch: item.tipoResearch.dsNome,
                                    status: status,
                                };
                                $this.lstResearchs.push(research);
                            }
                        } else {
                            avisoErro("Não foi possível carregar seus researchs.");
                        }
                    })
                    .catch(res => {
                        console.log(res);
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus researchs.");
                        }
                    });
            },

            imprimir(id) {
                let $this = this;
                $this.flImprimir = true;
                // Pass the element id here
                $this.$nextTick(function () {
                    $this.print(id);
                })
            },

            prev() {
                this.dtFim = moment(this.dtInicio, "DD/MM/YYYY").format('DD/MM/YYYY');
                this.dtInicio = moment(this.dtFim, "DD/MM/YYYY").add(-7, 'days').format('DD/MM/YYYY');
            },

            next() {
                if (moment(this.dtFim, "DD/MM/YYYY") < moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY")) {
                    this.dtInicio = moment(this.dtFim, "DD/MM/YYYY").format('DD/MM/YYYY');
                    this.dtFim = moment(this.dtFim, "DD/MM/YYYY").add(7, 'days').format('DD/MM/YYYY');
                }
            },

            async print(id) {
                let $this = this;
                await $this.$htmlToPaper(id, {
                    styles: [
                        'assets/css/style.css',
                        'assets/css/stylePrintRelatorioUso.css',
                        'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
                        //'assets/css/plugins/bootstrap.min.css',
                        //'assets/css/plugins/animation.css',
                        //'assets/css/plugins/feature.css',
                        //'assets/css/plugins/magnify.min.css',
                        //'assets/css/plugins/slick.css',
                        //'assets/css/plugins/slick-theme.css',
                        //'assets/css/plugins/lightbox.css',
                        //'assets/css/plugins/bootstrap-select.min.css',
                        //'assets/css/plugins/material-icons/css/materialicons.css',
                        //'assets/css/plugins/prism.css',
                    ],
                    "name": "_blank",
                    "windowTitle": "Utilizações SollAi"
                }, () => {
                    $this.flImprimir = false;
                    console.log('Printing completed or was cancelled!');
                });
            },

            
        },


        mounted: function () {
            this.load();

            //window.$(".popup-dashboardright-section").addClass("collapsed");
            //window.$(".rbt-main-content").addClass("area-right-expanded");
            //window.$(".rbt-static-bar").addClass("area-right-expanded");
        },
        watch: {
            dtInicio: function () {
                if (this.dtInicio == "" || this.dtInicio == null || this.dtInicio == undefined) {
                    this.dtInicio = moment().add(-7, 'days').format('DD/MM/YYYY');
                }
            },
            dtFim: function () {
                if (this.dtFim == "" || this.dtFim == null || this.dtFim == undefined) {
                    this.dtFim = moment().format('DD/MM/YYYY');
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   
    .table-responsive {
        max-height: 300px;
        color: black !important;
    }

    .z-99{
        z-index: 99;
    }

    .btn-filtrar {
        border-color: #ccc !important;
    }

    .filter-data{
        border: 1px solid #ccc;
    }
</style>

